import { useLocation, useParams } from "react-router-dom";
import { getController, getControllerUncached } from "../../../../../controllers/getter";
import { SamedayStatusController } from "../../../../../controllers/forms/sameday/Status";
import { MainWindow } from "../../../MainWindow";
import { Dynamic } from "../../../../../controllers/conductor";
import { Button } from "../../../../widgets/buttons";
import { LoadingAnimation } from "../../../../widgets/loading";
import { AlertDrawer } from "../../../../sections/sidebar/AlertDrawer";
import { ScrollingTable } from "../../../../widgets/table";
import { getMonthName, getRelativeDate, parseDateWithTime } from "../../../../../misc/date";
import { ApprovalIcon } from "../../../../widgets/approval";
import { MonthYearSelector } from "../../../../widgets/date_selector";
import Client from "../../../../../Client";

import "../../../../../styles/pages/samedaystatus.css";
import icons from "../../../../../assets/icons";
import { Pagination } from "../../../../widgets/pagination";
import { getLGUList } from "../../../../../services/api/meta";
import { Dropdown } from "../../../../widgets/input";


function SameDayStatus({ args: { tab } }) {

    const params = useParams();
    const query = new URLSearchParams(useLocation().search);

    const level = tab === "all" ? params.level : null;

    const ref = {
        lgu: query.get("l"),
        province: query.get("p"),
        offset: Number(query.get("o")) || 0,
        month: Number(query.get("m")),
        year: Number(query.get("y"))
    };

    /** @type { SamedayStatusController } */
    const controller = getControllerUncached(SamedayStatusController, { tab, level, ref });
    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="forms" subtab="sameday">
        <Dynamic conductor={[ notifiers.loading, notifiers.error ]} child={()=>
           status.error ? <ErrorScreen controller={controller} /> : (!status.loading ? <Main controller={controller} /> : <LoadingWindow />)
        } />
    </MainWindow>);
}

/** @param {{ controller: SamedayStatusController }} param0 */
function ErrorScreen({ controller }) {
    return <div>
        An error occured.
        <Button onClick={() => controller.refresh()}>Try Again</Button>
    </div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}

/** @param {{ controller: SamedayStatusController }} param0 */
function Main({ controller }) {
    return <div className="form-main status">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <Tabs controller={controller}/>
        <Body controller={controller} />
    </div>;
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Header({ controller }) {
    return <header>
        <div className="left">
            <h2>Sameday Visitors Report</h2>
        </div>
        <div className="buttons">
            <Button icon="refresh" onClick={() => controller.refresh()}>Refresh</Button>
        </div>
    </header>;
}


const TABS_CONFIGS = {
    all: { label: "ALL" },  
    pending: { label: "PENDING", color: "#2C74A8" },  
    returned: { label: "RETURNED", color: "#676767" },  
    published: { label: "PUBLISHED", color: "#4D9642" },  
};

/** @param {{ controller: SamedayStatusController }} param0 */
function Tabs({ controller }) {
    const { tabs, currentTab, data, notifiers, status } = controller;

    console.log(data);

    const tabViews = tabs.map(tab => {
        const configs = TABS_CONFIGS[tab];
        const statusValues = data.status;
        const quantity = statusValues ? statusValues[tab] : 0;
        return Tab({ active: currentTab === tab, 
            ...configs, quantity,
            onClick: () => controller.gotoTab(tab) });
    });

    return <Dynamic conductor={[ notifiers.changingTab ]} child={()=>
        <div className="status-tabs" key={Math.random()}>{tabViews}</div>} />;
}


function Tab({ active = false, icon, label, sublabel, color = "#222", quantity, onClick }) {
    return <div key={Math.random()} className={"status-tabs-item" + (active ? " active" : "")} onClick={onClick}>
        { icon ? <div className="status-tabs-icon-section">
                <img src={icon} alt=""/>
            </div> : [] }
        <div className="status-tabs-label-section">
            <div className="status-tabs-label" style={{ color }}>{label}</div>
            { sublabel ? <div className="sublabel">{sublabel}</div> : [] }
            { quantity ? <div className="status-tabs-quantity">{quantity}</div> : [] }
        </div>
    </div>;
}

/** @param {{ controller: SamedayStatusController }} param0 */
function Body({ controller }) {
    const { notifiers, status } = controller;

    return <Dynamic conductor={[ notifiers.changingTab ]} child={()=>
        !status.changingTab ? {
            all: () => Tab_All({ controller }),
            pending: () => Tab_Pending({ controller }),
            returned: () => Tab_Returned({ controller }),
            published: () => Tab_Published({ controller })
        }[controller.currentTab]() :
        <LoadingWindow /> } />;
}





/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_All({ controller }) {
    return {
        provinces: () => Tab_All_Provinces({ controller }),
        province: () => Tab_All_Province({ controller }),
        lgu: () => Tab_All_LGU({ controller }),
    }[controller.currentLevel]();
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_All_Provinces({ controller }) {
    const provinces = controller.data.provinces;
    console.log(provinces);

    const columns = [
        { title: "PROVINCES", width: "250px" },
    ];

    const rows = provinces.map(province => [ province.name ]);

    const onRowClick = (rowIndex) => {
        const province = provinces[rowIndex];
        console.log("SELECTED PROVINCE:", province.id);
        controller.gotoLevel("province", { province: province.id });
    };

    return <div className="tab-main all-province">
        <main>
        <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick}/>    
        </main>    
    </div>;
}

/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_All_Province({ controller }) {
    const { month, year, province, lgus } = controller.data.province;
    const dateString = getMonthName(month) + " " + year;

    const columns = [
        { title: "", width: "40%" },
        { title: "TOURISM OFFICE", width: "20%" },
        { title: "PROVINCE", width: "20%" },
        { title: "REGION", width: "20%" },
    ];

    const rows = lgus.map(({ name, submissionLevels: { local, province, region }}) => [ 
        name,
        local ? <ApprovalIcon /> : [],
        province ? <ApprovalIcon /> : [],
        region ? <ApprovalIcon /> : [],
    ]);

    const onRowClick = (rowIndex) => {
        const lgu = lgus[rowIndex];
        controller.gotoLevel("lgu", { lgu: lgu.id });
    };

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);
    
    return <div className="tab-main all-province">
        <header>
            <div className="left">
                <h3>{province.name} Province</h3>
                <span>{dateString}</span>
            </div>
            <div className="right">
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>
        <main>
            <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick}/>
        </main>
    </div>;
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_All_LGU({ controller }) {
    const { lgu, month, year, draft, submission } = controller.data.lgu;
    const dateString = getMonthName(month) + " " + year;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    function getStatusImage(level) {
        const { levels, currentLevel } = submission;
        if(levels[level]) return icons.status_check_filled;

        if(currentLevel === level || currentLevel === "returned-"+level) 
            return icons.status_check_current;

        return icons.status_check_inactive;
    }

    function getStatusClassname(level) {
        const { levels, currentLevel } = submission;
        if(levels[level]) return " done";

        if(currentLevel === level || currentLevel === "returned-"+level) 
            return " current";

        return "";
    }

    let statusMessage = "";

    if(submission) {
        if(submission.currentLevel === "local") statusMessage = "Not yet submitted";
        else if(submission.currentLevel === "returned-local") statusMessage = "Report was returned to T.O., waiting to be resubmitted.";
        else if(submission.currentLevel === "province") statusMessage = "Waiting to be approved by Provincial Tourism Office.";
        else if(submission.currentLevel === "returned-province") statusMessage = "Report was returned to P.T.O., waiting to be reapproved.";
        else if(submission.currentLevel === "region") statusMessage = "Waiting to be approved by R.O.";
        else if(submission.currentLevel === "published") statusMessage = "This report is now published.";
    }
    

    return <div className="tab-main all-lgu">
        <header>
            <div className="left">
                <h3>{lgu.name}, {lgu.province.name}</h3>
                <span>{dateString}</span>
            </div>
            <div className="right">
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>
        <main>
            {
                !draft && !submission ? <div className="row new">
                <header>
                    <div className="left">
                        <div className="title">A report for this month is not yet created.</div>
                    </div>
                    <div className="right">
                        { Client.account.role === "lgu" ? <Button color="green" onClick={() => controller.viewDraft({ lgu: lgu.id, month, year })}>CREATE REPORT</Button> : [] }
                    </div>
                </header>
                
            </div> : []
            }
            {
                draft ? <div className="row draft">
                    <header>
                        <div className="left">
                            <div className="title">A draft report is currently active for editing.</div>
                            <div className="details">Last updated on <b>{parseDateWithTime(draft.lastUpdated.on)}</b> by <b>{
                                draft.lastUpdated.by.id === Client.account.id ? "you" : draft.lastUpdated.by.fullname }</b>.</div>
                        </div>
                        <div className="right">
                            <Button color="green" onClick={() => controller.viewDraft({ lgu: lgu.id, month, year })}>CONTINUE EDITING</Button>
                        </div>
                    </header>
                </div> : []
            }
            {
                submission ? <div className="row submission">
                    <header>
                        <div className="left">
                            <div className="title">A report has been submitted for this month.</div>
                        </div>
                    </header>
                    <main>
                        <div className="columns">
                            <div className="left">
                                <div className="progress">
                                    <div className={"check-stop handle" + getStatusClassname("local")}>
                                        <img src={getStatusImage("local")} className="check" alt="" />
                                        <div className="level-label">{ lgu.type === "municipality" ? "Municipal Tourism" : "City Tourism" }</div>
                                        { submission.levels.local ? <div className="level-date">{ parseDateWithTime(submission.levels.local.on) }</div> : [] }
                                    </div>
                                    <div className={"check-stop handle" + getStatusClassname("province")}>
                                    <img src={getStatusImage("province")} className="check" alt="" />
                                        <div className="level-label">Province</div>
                                        { submission.levels.province ? <div className="level-date">{ parseDateWithTime(submission.levels.province.on) }</div> : [] }
                                    </div>
                                    <div className={"check-stop"}>
                                    <img src={getStatusImage("region")} className="check" alt="" />
                                        <div className="level-label">Region</div>
                                        { submission.levels.region ? <div className="level-date">{ parseDateWithTime(submission.levels.region.on) }</div> : [] }
                                    </div>
                                </div>
                                { statusMessage ? <div className="status-message">
                                    <b>STATUS:</b> {statusMessage}
                                </div> : [] }
                            </div>

                            <div className="right">
                                { submission.levels.local ? [
                                    <div className="completion-label" key="1">ID: <b>{submission.refId}</b></div>,
                                    <div className="submission-date" key="2">submitted on <b>{parseDateWithTime(submission.levels.local.on)}</b></div>,
                                    <div className="submission-by" key="3">submitted by <b>{ submission.levels.local.by.fullname }</b></div> ] : [] }
                                <Button color="green" onClick={() => controller.viewReport(submission.id)}>VIEW REPORT</Button>
                            </div>
                        </div>
                        
                    </main>
                    
                </div> : []
            }
        </main>
    </div>;
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_Pending({ controller }) {
    const { pending } = controller.data;

    const columns = [
        { title: "ID", width: "10%" },
        { title: "", width: "27%" },
        { title: "REPORT DATE", width: "15%" },
        { title: "DATE SUBMITTED", width: "25%" },
        { title: "AUTHOR", width: "23%" },
    ];

    const rows = pending.map(report => [ 
        report.refId,
        <b key="1">{report.lgu.name}, {report.lgu.province.name}</b>,
        getMonthName(report.month) + " " +  report.year,
        <div key="2">
            <div>{ parseDateWithTime(report.submitted.on) }</div>
        </div>,
        report.author.fullname
    ]);

    const onRowClick = (rowIndex) => {
        controller.viewReport(pending[rowIndex].id);
    };
    
    return <div className="tab-main pending">
        <main>
            {
                rows.length > 0 ? <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick}/> :
                <EmptyScreen title="Nothing to show" description="There are no pending reports for you" />
            }
        </main>
    </div>;
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_Returned({ controller }) {
    const { returned } = controller.data;

    const columns = [
        { title: "ID", width: "10%" },
        { title: "", width: "27%" },
        { title: "REPORT DATE", width: "15%" },
        { title: "DATE RETURNED", width: "25%" },
        { title: "AUTHOR", width: "23%" },
    ];

    const rows = returned.map(report => [ 
        report.refId,
        <b key="1">{report.lgu.name}, {report.lgu.province.name}</b>,
        getMonthName(report.month) + " " +  report.year,
        <div key="2">
            <div>{ parseDateWithTime(report.returned.on) }</div>
        </div>,
        report.author.fullname
    ]);

    const onRowClick = (rowIndex) => {
        controller.viewReport(returned[rowIndex].id);
    };
    
    return <div className="tab-main returned">
        <main>
            {
                rows.length > 0 ? <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick}/> :
                <EmptyScreen title="Nothing to show" description="There are no returned reports for you" />
            }
        </main>
    </div>;
}


/** @param {{ controller: SamedayStatusController }} param0 */
function Tab_Published({ controller }) {
    const { published, dropdownOptions } = controller.data;

    const columns = [
        { title: "ID", width: "10%" },
        { title: "", width: "40%" },
        // { title: "REPORT DATE", width: "15%" },
        { title: "DATE PUBLISHED", width: "25%" },
        { title: "AUTHOR", width: "25%" },
    ];


    const { month, year, province, lgu } = controller.reference;
    const dateString = getMonthName(month) + " " + year;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    const rows = published.results.map(report => [ 
        report.refId,
        <b key="1">{report.lgu.name}, {report.lgu.province.name}</b>,
        <div key="2">
            <div>{ parseDateWithTime(report.published.on) }</div>
        </div>,
        report.author.fullname
    ]);

    const onRowClick = (rowIndex) => {
        controller.viewReport(published.results[rowIndex].id);
    };

    const { offset, limit, total } = published;
    const onChangePage = (page) => {
        controller.changePublishedOffset(Math.floor((page - 1)*limit));
    };

    const onChangeLGU = (lgu) => controller.changePublishedLGU(lgu);
    const onChangeProvince = (province) => controller.changePublishedProvince(province);
    

    return <div className="tab-main published">
        <header>
            <div className="left">
                <h3>Published Reports</h3>
                <span>{dateString}</span>
            </div>
            <div className="right">
                { dropdownOptions.lgus ? <Dropdown options={dropdownOptions.lgus} onSelect={onChangeLGU} defaultValue={lgu || 0} /> : [] }
                { dropdownOptions.provinces ? <Dropdown options={dropdownOptions.provinces} onSelect={onChangeProvince} defaultValue={province || 0} /> : [] }
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>
        <main>
            {
                rows.length > 0 ? <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick}/> :
                <EmptyScreen title="Nothing to show" description="There are no published reports with the given parameters" />
            }
        </main>
        { rows.length > 0 ? <Pagination offset={offset} pageSize={limit} total={total} onChangePage={onChangePage} /> : [] }
    </div>;
}


function EmptyScreen({ title, description }) {
    return <div className="empty-screen">
        <img src={icons.file_search} alt=""/>
        <div className="title">{title}</div>
        <div className="description">{description}</div>
    </div>
}



export default SameDayStatus;